export const materialData = [
    {
        id: 1,
        name: "Cement",
        unit: "Bags",
        opening: 500,
        purchased: 820,
        consumed: 940,
        closing: 380,
        totalSpend: 472000,
        status: "OK",
        percentage: 72,
        statusType: "success",
    },
    {
        id: 2,
        name: "Steel Rebar",
        unit: "Tons",
        opening: 15.5,
        purchased: 25,
        consumed: 33.2,
        closing: 7.3,
        totalSpend: 1985000,
        status: "Short",
        percentage: 96,
        statusType: "error",
    },
    {
        id: 3,
        name: "Sand",
        unit: "Tons",
        opening: 80,
        purchased: 120,
        consumed: 92,
        closing: 108,
        totalSpend: 176000,
        status: "Excess",
        percentage: 52,
        statusType: "warning",
    },
    {
        id: 4,
        name: "Ready Mix Concrete",
        unit: "m³",
        opening: 60,
        purchased: 140,
        consumed: 155,
        closing: 45,
        totalSpend: 525000,
        status: "Short",
        percentage: 90,
        statusType: "error",
    },
    {
        id: 5,
        name: "Bricks",
        unit: "Units",
        opening: 12000,
        purchased: 18000,
        consumed: 16000,
        closing: 14000,
        totalSpend: 320000,
        status: "OK",
        percentage: 65,
        statusType: "success",
    },
    {
        id: 6,
        name: "Electrical Cables",
        unit: "Rolls",
        opening: 10,
        purchased: 15,
        consumed: 22,
        closing: 3,
        totalSpend: 285000,
        status: "Critical",
        percentage: 98,
        statusType: "error",
    }
];

export const emergencyPurchases = [
    {
        id: 1,
        name: "Steel Rebar",
        reason: "Urgent requirement for foundation reinforcement",
        date: "15 Jan 2026",
        cost: "4,25,000"
    },
    {
        id: 2,
        name: "Ready Mix Concrete",
        reason: "Unexpected slab pour extension",
        date: "22 Jan 2026",
        cost: "3,10,000"
    },
    {
        id: 3,
        name: "PVC Conduits",
        reason: "Extra electrical routing changes",
        date: "29 Jan 2026",
        cost: "95,000"
    }
];

export const excessConsumption = [
    {
        id: 1,
        name: "Electrical Cables",
        task: "Electrical Installation",
        status: "CRITICAL",
        estimated: 80,
        actual: 96,
        statusType: "critical"
    },
    {
        id: 2,
        name: "Steel Rebar",
        task: "Foundation Work",
        status: "CRITICAL",
        estimated: 85,
        actual: 97,
        statusType: "critical"
    },
    {
        id: 3,
        name: "Ready Mix Concrete",
        task: "Parking Slab",
        status: "WARNING",
        estimated: 75,
        actual: 86,
        statusType: "warning"
    }
];

export const procurementForesightData = [
    {
        id: 1,
        material: "Steel Rebar",
        requiredQty: "35 Tons",
        availableQty: "12 Tons",
        toPurchase: "23 Tons",
        timeline: "Week 1-2",
        estCost: "21,00,000"
    },
    {
        id: 2,
        material: "Electrical Cables",
        requiredQty: "20 Rolls",
        availableQty: "5 Rolls",
        toPurchase: "15 Rolls",
        timeline: "Week 2",
        estCost: "4,50,000"
    },
    {
        id: 3,
        material: "Cement",
        requiredQty: "900 Bags",
        availableQty: "380 Bags",
        toPurchase: "520 Bags",
        timeline: "Week 3",
        estCost: "2,85,000"
    },
    {
        id: 4,
        material: "Waterproofing Chemical",
        requiredQty: "1,200 L",
        availableQty: "300 L",
        toPurchase: "900 L",
        timeline: "Week 4",
        estCost: "1,75,000"
    }
];
